// Base URL for the API
export const endpoints = {
  TESTAPI_URL: "https://jsonplaceholder.typicode.com/posts",
  MITCO_API_URL: process.env.REACT_APP_API_URL,

  // Authentication Endpoints
  USER_LOGIN: "/users/login/",
  USER_LOGOUT: "/users/logout/",

  ORDER_READ: "/suborder/",
  CREDIT_BASE: "credits/",
  INVOICE_BASE: "invoices/",
  CSFA_CREDIT_BASE: "/csfa/csfa_credits/",
  CSFA_QUOTE_BASE: "/csfa/csfa_quotes/",
  CREDIT_PRINT: "print_confirmation",
  INVOICES: "/reports/print_invoice/",

  LOGS_BASE: "/v1/logs/",

  CSFA_BASE: "/v1/csfa/",
  CSFA_PRODUCTS: "csfa_products/",
  CSFA_ORDER_LIST: "get_order_list/",
  CSFA_INITIAL_PRODUCTS: "get_products/",
  CSFA_SEARCH_PRODUCTS: "search_products/",
  CSFA_DETAIL_PRODUCT: "get_product_detail/",
  CSFA_PRODUCT_ROW_DETAIL: "get_product_calc/",
  CSFA_TRACK_MAKE_MODEL_MATCHES: "get_track_matches/",
  CSAF_PRODUCT_TYPE_FILTERS: "get_product_type_filters/",
  CSFA_PRODUCT_MANUFACTURERS: "get_product_manufacturer_filters/",
  CSFA_PRODUCT_MODELS: "get_product_models/",
  CSFA_PRODUCT_HISTORY: "product_history_filter/",
  CSFA_ALTERNATIVE_PRODUCT: "get_alternative_product/",
  CSFA_ORDERS: "csfa_orders/",
  CSFA_ORDERS_SHIPPING_INFO: "collect_shipping_info/",
  CSFA_ORDERS_SHIPPING_INFO_ASYNC: "collect_shipping_info_async/",
  CSFA_SHIPPING_JOB_STATUS: "shipping_rating_status/",
  CSFA_ORDERS_CREATE: "create_order/",
  CSFA_ORDERS_HISTORY: "get_order_history/",
  CSFA_ORDER: "get_order/",
  CSFA_CUSTOMER: "csfa_customer/",
  CSFA_CUSTOMER_CUTOFF: "get_customer_cutoff/",
  CSFA_CUSTOMER_DETAILS_FOR_ORDER: "get_base_customer_information/",
  CSFA_CUSTOMER_LOGIN_AS: "get_login_as_list/",
  CSFA_CHANGE_LOGIN_CUST: "switch_login_cust/",
  CSFA_CART: "csfa_cart/",
  CSFA_CART_ITEMS: "csfa_cart_items/",
  CSFA_CART_ITEM_AS_ORDER_ITEM: "get_orderitem_representation/",
  CSFA_GET_TRACK_FEE: "get_track_fee/",
  // We don't update the cart directly, it is just recalculated whenever an item is changed
  CSFA_UPDATE_CARTITEM: "update_cartitem/",
  CSFA_SITE_ADMIN: "csfa_site_admin/",
  CSFA_TEMPLATE_USERS: "get_template_users/",
  CSFA_INITIAL_ADMIN_VARS: "initial_csfa_admin/",
  CSFA_SAVE_IMAGES: "save_image/",
  CSFA_UPDATE_IMAGES: "update_image/",
  CSFA_DELETE_IMAGES: "delete_image/",
  CSFA_UPDATE_SITE_PROPERTIES: "update_site_properties/",
  CSfA_VALIDATE_ADDRESS: "/validateAddress/",
  CSFA_ZIP_LOOKUP: "/validateAddress/",

  // API Request Logs Endpoints
  CSFA_API_LOGS: "api-logs/",

  // Version Endpoints
  VERSIONS_BASE: "/v1/application_versions/",
  VERSION_BY_NAME: "get_version_by_name/",
  VERSION_CHECK_NEW: "new_version_available/",
};
